import BlogForm from "./BlogForm";

const AddBlog = () => {
  return (
    <>
      <BlogForm action="Add" />
    </>
  );
};

export default AddBlog;


